import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { ActionBar, ButtonRow, DashList, DataListWrap, ModalContent, Td, TitleLeft, TrMain, TrSub } from './CourseModal.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import Tooltip from '@components/Tooltips/Tooltip';
import SortArrow from '@components/SchoolLeader/SortArrow';
import Excel_Icon from "@assets/svg/excel.svg";
import SubCourse_Icon from "@assets/svg/indent_arrow.svg";
import fixedNumber from '@utils/fixedNumber';
import React from 'react';
import { ShowabsenceOrAttendance } from '@utils/percentageTools';

interface IProps {
  selectedStudent: any
}

export const CourseModal = (props: IProps) => {
  const { client, filterDate, callNameSetting, settings } = useStore();
  const [courses, setCourses] = useState(null)
  const i18n = useI18n();

  useEffect(() => {
    if (props.selectedStudent) getStudent()
  }, [props.selectedStudent])

  const getStudent = async () => {
    let studentData = await db.GetCourseAbsenceForStudent(filterDate.from, filterDate.to, props.selectedStudent.student_id)
    let courses = []
    let courseIds = [...new Set(studentData.map((item) => item.course_id))]
    for (let i = 0; i < courseIds.length; i++) {
      const courseId = courseIds[i];
      let subjects = studentData.filter(c => c.course_id === courseId)
      let courseDuration = 0
      let courseAbsenceDuration = 0
      let course_name = ""
      let percentage = 0;
      for (let j = 0; j < subjects.length; j++) {
        const subject = subjects[j];
        courseDuration = courseDuration + subject.lesson_duration;
        courseAbsenceDuration = courseAbsenceDuration + subject.absence_duration
        course_name = subject.course_name
      }
      percentage = courseAbsenceDuration / courseDuration * 100
      courses.push({ id: courseId, course_name, courseDuration, courseAbsenceDuration, percentage, subjects })
    }
    setCourses(courses)
  }

  const getTime = (duration) => {
    let minutes = duration/60
    let hours = Math.floor(minutes/60)
    let timeString = hours + i18n.t('hour') + " " + Math.floor(minutes%60) + i18n.t('minute')
    return timeString
}

  return (<>
    <TitleLeft>
      {props.selectedStudent.displayname}

      <ActionBar>
        {//<Excel_Icon />
        }
      </ActionBar>
    </TitleLeft>

    <DataListWrap>
      <DashList>
        <tbody>
          <tr>
            <Td>{i18n.t("course&subject")}</Td>
            <Td>{i18n.t("time-missed")}</Td>
            <Td>{i18n.t("total-time")}</Td>
            <Td>{i18n.t(settings.SHOWPRESENCE?"attendance":"absence")}</Td>
          </tr>
          {courses?.map((c, index) => {
            let subjects = c.subjects.map((s, i) => <TrSub key={index + "_subject_" + i}>
              <td><SubCourse_Icon />{s.course_description}</td>
              <td>{getTime(s.absence_duration)}</td>
              <td>{getTime(s.lesson_duration)}</td>
              <td>{ShowabsenceOrAttendance(settings.SHOWPRESENCE ,fixedNumber(s.percentage))}%</td>
            </TrSub>)

            return <React.Fragment key={"course_" + index}><TrMain>
              <td>{c.course_name}</td>
              <td>{getTime(c.courseAbsenceDuration)}</td>
              <td>{getTime(c.courseDuration)}</td>
              <td>{ShowabsenceOrAttendance(settings.SHOWPRESENCE ,fixedNumber(c.percentage))}%</td>
            </TrMain>{subjects}</ React.Fragment>
          })}
        </tbody>
      </DashList>
    </DataListWrap>
  </>);
};

export default CourseModal;
